var map = {
	"./1.png": 6628,
	"./10.png": 3470,
	"./2.png": 1119,
	"./3.png": 2102,
	"./4.png": 1497,
	"./5.png": 5248,
	"./6.png": 6539,
	"./7.png": 5410,
	"./8.png": 9941,
	"./9.png": 7052
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8010;